module.exports = __webpack_public_path__ + "fonts/Lato-400-latin2.efee2d0.woff2";